import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { DeviceFaultFixerGetOptionsPathParameters } from 'api/actions/device-fault-fixer-get-options/device-fault-fixer-get-options-path-parameters';
import { DeviceFaultFixerGetOptionsResponse } from 'api/actions/device-fault-fixer-get-options/device-fault-fixer-get-options-response';

type DeviceFaultFixerGetOptionsQueryParameters = Record<string, any>;

/**
 * The path of the DeviceFaultFixerGetOptions action.
 */
export const deviceFaultFixerGetOptionsActionPath = new SweetPath<keyof DeviceFaultFixerGetOptionsPathParameters>(
  '/api/device/faults/{deviceId}/fixer-options',
  { path: '{param}' }
);

/**
 * Creates a contextualized DeviceFaultFixerGetOptions actions.
 */
export default function createDeviceFaultFixerGetOptionsAction(axios: AxiosInstance) {
  return function deviceFaultFixerGetOptionsAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: DeviceFaultFixerGetOptionsPathParameters;
    query?: DeviceFaultFixerGetOptionsQueryParameters;
  }) {
    const path = deviceFaultFixerGetOptionsActionPath.insert(parameters);

    return axios.request<DeviceFaultFixerGetOptionsResponse, DeviceFaultFixerGetOptionsResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
